export default __webpack_public_path__ + "static/media/done-green.2dac13a7.svg";